
















































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import GroupEditor from '@/views/document/GroupEditor.vue';
import CompanySelection from '@/components/CompanySelection.vue';
import user from '@/store/modules/user';
import SectionEditor from '@/views/document/SectionEditor.vue';
import TextEditor from '@/views/document/report/TextEditor.vue';

@Component({
  components: {SectionEditor, CompanySelection, GroupEditor, TextEditor},
})
export default class DocumentEditor extends Vue {
  @Prop() readonly subType!: any;
  @Prop() readonly documentId!: any;
  @Prop() readonly documentBlobId!: any;

  loaded: boolean = false;
  company: any = null;
  competitor1: any = null;
  competitor2: any = null;
  selectedCompany: any = null;
  selectedSource: any = null;
  selectedBranch: any = null;
  selectedCompetitor1: any = null;
  selectedCompetitor2: any = null;

  over: number = -1;

  translate: boolean = false;

  async mounted() {
    if (this.editing) {
      await dokument.loadDocument(this.documentBlobId);
      if (dokument.loaded) {
        this.translate = dokument.Language === 'en';
        const c = await user.getCompany(dokument.OrgNr);
        if (c) {
          this.company = {
            value: c.OrgNr,
            label: c.Name,
            Branch: dokument.Bransch,
            BranchText: dokument.BranschText,
            dateTo: c.DateTo,
            SieAggVersion: dokument.SieAggVersion,
          };
        }
        if (dokument.Competitor1) {
          const c1 = await user.getCompany(dokument.Competitor1);
          if (c1) {
            this.competitor1 = {
              value: c1.OrgNr,
              label: c1.Name,
              Branch: '   ',
            };
          }
        }
        if (dokument.Competitor2) {
          const c2 = await user.getCompany(dokument.Competitor2);
          if (c2) {
            this.competitor2 = {
              value: c2.OrgNr,
              label: c2.Name,
              Branch: '   ',
            };
          }
        }
      }
    } else {
      switch (this.subType) {
        case 'cashflow':
          await dokument.initCashflow();
          break;
        case 'flexible':
          await dokument.initFlexible();
          break;
        case 'company':
          await dokument.initCompany();
          break;
        case 'industryAnalysis':
          await dokument.initIndustryAnalysis();
          break;
        case 'competitorAnalysis':
          await dokument.initCompetitorAnalysis();
          break;
        case 'webreport_cashflow':
          await dokument.initWebreportCashflow();
          break;
        case 'preClosingMeeting':
          await dokument.initPreClosingMeeting();
          break;
        default:
          await dokument.initEmpty();
      }
    }
    this.loaded = true;
  }

  @Watch('translate')
  translateChanged() {
    const lang = this.translate ? 'en' : 'sv';
    if (dokument.Language !== lang) {
      dokument.setLangugage(lang);
    }
  }

  @Watch('selectedCompany')
  companyChanged() {
    if (!this.selectedCompany) {
      dokument.setCompany('');
    } else {
      if (this.selectedCompany.value === dokument.OrgNr) {
        return;
      }
      dokument.setCompany(this.selectedCompany.value);
      dokument.loadData();
    }
  }

  @Watch('selectedSource')
  selectedSourceChanged() {
    // console.log(this.selectedSource, dokument.SieAggVersion);
    if (!this.selectedSource) {
      dokument.setSource({
        BasedOn: '',
        SieAggVersion: 0,
      });
    } else {
      // if (this.selectedSource.id === dokument.SieAggVersion) {
      //   return;
      // }
      dokument.setSource({
        BasedOn: this.selectedSource.source,
        SieAggVersion: this.selectedSource.id,
      });
      dokument.loadData();
    }
  }

  @Watch('selectedBranch')
  selectedBranchChanged() {
    if (!this.selectedBranch) {
      dokument.setBranch({
        Bransch: '',
        BranschText: '',
      });
    } else {
      // if (this.selectedBranch.id === dokument.Bransch) {
      //   return;
      // }
      dokument.setBranch({
        Bransch: this.selectedBranch.id,
        BranschText: this.selectedBranch.text,
      });
    }
  }

  @Watch('selectedCompetitor1')
  competitor1Changed() {
    if (!this.selectedCompetitor1) {
      dokument.setCompetitor1('');
      dokument.setCompetitor2('');
    } else {
      dokument.setCompetitor1(this.selectedCompetitor1.value);
      dokument.loadData();
    }
  }

  @Watch('selectedCompetitor2')
  competitor2Changed() {
    if (!this.selectedCompetitor2) {
      dokument.setCompetitor2('');
    } else {
      dokument.setCompetitor2(this.selectedCompetitor2.value);
      dokument.loadData();
    }
  }

  async create() {
    if (!this.canCreate) {
      return;
    }
    await dokument.saveDocument(this.documentId);
    if (this.editing) {
      await user.getUser('Uppdaterar dokument');
    } else {
      await user.getUser('Skapar dokument');
    }
    const OrgNr = this.selectedCompany.value;
    this.$router.push({name: 'documents', params: {OrgNr}});
  }

  handleDrop(data: any) {
    dokument.moveItem({source: data.index, target: this.over});
    this.over = -1;
  }

  add(type: string) {
    dokument.add(type);
  }

  droppable(type: string) {
    switch (type) {
      case 'cover':
      case 'completion':
      case 'liability':
      case 'webreport_cashflow':
        return false;
      default:
        return true;
    }
  }

  get allowCustomContent() {
    return this.subType !== 'industryAnalysis' &&
        this.subType !== 'competitorAnalysis' &&
        this.subType !== 'preClosingMeeting' &&
        this.subType !== 'webreport_cashflow';
  }

  get allowTranslation() {
    return this.subType !== 'webreport_cashflow';
  }

  get canCreate() {
    return dokument.canSaveDocument;
  }

  get id(): string {
    return this.documentId;
  }

  get title() {
    switch (this.subType) {
      case 'cashflow':
        return 'Förenklad kassaflödesanalys';
      case 'flexible':
        return 'Flexibel presentation';
      case 'company':
        return 'Bolagsanalys';
      case 'industryAnalysis':
        return 'Branschjämförelse';
      case 'competitorAnalysis':
        return 'Konkurrentjämförelse';
      case 'webreport_cashflow':
        return 'Förenklad kassaflödesanalys (Webbrapport)';
      case 'preClosingMeeting':
        return 'Inför bokslut';
      default:
        return '';
    }
  }

  get items() {
    return dokument.getItems(0).filter((x) =>
        ['preClosingMeeting_intro', 'preClosingMeeting_future', 'preClosingMeeting_feedback', 'preClosingMeeting_nextMeeting'].indexOf(x.Type) === -1);
  }

  get summaryItems() {
    return dokument.getItems(0).filter((x) => x.Category === 'summary');
  }

  get editing() {
    return this.documentId !== undefined;
  }

  get useBranch() {
    switch (this.subType) {
      case 'company':
      case 'flexible':
      case 'industryAnalysis':
        return true;
    }
    return false;
  }

  get sheetLimit() {
    switch (this.subType) {
      case 'company':
      case 'industryAnalysis':
      case 'competitorAnalysis':
        return 1;
    }
    return 2;
  }
}
